require("babel-polyfill");
require('@/assets/css/reset.css');
require('@/assets/css/app.css');
require('@/assets/css/index.css');
require('@/assets/css/qjzxAsk.css');
require('@/assets/css/qjzxSelect.css');
require('@/assets/css/qjzxAnswer.css');
require("@/service/jquery.pseudo");
require("@/service/public");
require("@/service/api");
var App = require('C/app');

var $el = document.getElementById('app');

var Main = san.defineComponent({
    template: '<div><app /></div>',
    components: {
        'app': App
    },
    created: function() {
        this.safeInfo();
    },
    safeInfo: function(){
        if(!!localStorage.safeInfo){}else{
            var me = this;
            $.ajax({
                url: '/api/websafe/safeInfo?domainName='+document.domain,
                type: 'get',
                dataType : 'json',
                contentType: 'application/json',
                data: null,
                success: function(response){
                    localStorage.safeInfo = response.safeInfo;
                },
                error: function(err) {

                }
            });
        }
    }
});

var body = new Main();
body.attach($el);

/* webpack 热替换 */
// if (module.hot) {
//     module.hot.accept();
// }



//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = 139
// module chunks = 1